import {
  Injectable,
} from '@angular/core';
import {
  Observable,
} from 'rxjs';

import {
  ServerVersionDto,
} from 'webcommon/shared';

import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class VersionRepository {
  constructor(
    private prmHttpClientService: PrmHttpClientService,
  ) {
  }

  getMinClientVersion(): Observable<string> {
    const endpointUrl = `minclientversion`;
    return this.prmHttpClientService.sendGetRequest(endpointUrl);
  }

  getApiVersions(): Observable<string[]> {
    const endpointUrl = `apiversions`;
    return this.prmHttpClientService.sendGetRequest(endpointUrl);
  }

  getServerVersions(): Observable<ServerVersionDto> {
    const endpointUrl = `serverversions`;
    return this.prmHttpClientService.sendGetRequest(endpointUrl);
  }
}
